import { importChargingStations } from '@infuse/api/e-connector/charging-station';
import { useNotify } from '@infuse/cpms/ui';
import { mapImportedChargingStationsToDomain } from '@infuse/e-connector/charging-station/domain';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useImportChargingStations = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure, notifyInfo } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const response = await importChargingStations({}, formData);
      return mapImportedChargingStationsToDomain(response);
    },
    onSuccess: async (importResponse) => {
      await queryClient.invalidateQueries({ queryKey: ['charging-stations'] });

      if (importResponse.failed.length) {
        notifyInfo({
          title: t('e_connector.chargingStations.notify.import.partial.title'),
          message: t('e_connector.chargingStations.notify.import.partial.message', {
            count: importResponse.imported.length,
            failedCount: importResponse.failed.length
          })
        });
      } else {
        notifySuccess({
          title: t('e_connector.common.notify.success'),
          message: t('e_connector.chargingStations.notify.import.success', {
            count: importResponse.imported.length
          })
        });
      }
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.chargingStations.notify.import.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
